import React, { useEffect, useRef } from 'react';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  SLOT_DURATION_CHOICES,
  SLOT_HEADER_INTERVAL_CHOICES,
  TIME_FORMAT_CHOICES,
} from '../../OpSchedulerConstants';
import './opSchedulerSettingsPanel.css';

function OpSchedulerSettingsPanel({
  extraSettingItems = [],
  isOpen,
  onClose,
  onOptionChange,
  options,
}) {
  const panelRef = useRef(null);

  const settingItems = [
    {
      key: 'slotDuration',
      label: 'Slot Duration',
      value: options.slotDuration,
      choices: SLOT_DURATION_CHOICES,
      onChange: (args) => onOptionChange('slotDuration', args.value),
    },
    {
      key: 'slotHeaderInterval',
      label: 'Slot Header Interval',
      value: options.slotHeaderInterval,
      choices: SLOT_HEADER_INTERVAL_CHOICES,
      onChange: (args) => onOptionChange('slotHeaderInterval', args.value),
    },
    {
      key: 'timeFormat',
      label: 'Time Format',
      value: options.timeFormat,
      choices: TIME_FORMAT_CHOICES,
      onChange: (args) => onOptionChange('timeFormat', args.value),
    },
    {
      key: 'tooltip',
      label: 'Tooltip',
      value: options.tooltip,
      choices: [
        { label: 'On', value: 'on' },
        { label: 'Off', value: 'off' },
      ],
      onChange: (args) => onOptionChange('tooltip', args.value),
    },
  ];

  const allSettingItems = [...settingItems, ...extraSettingItems];

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (panelRef.current && panelRef.current.contains(event.target)) return;
      if (event.target.closest('.op-scheduler-settings-toggle')) return;
      if (event.target.closest('.e-popup')) return;
      onClose?.();
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isOpen, onClose]);

  return (
    <div
      ref={panelRef}
      className={`op-scheduler-settings-panel ${isOpen ? 'op-scheduler-settings-panel--open' : ''}`.trim()}
    >
      <div className="op-scheduler-settings-panel__body">
        {allSettingItems.map((item) => (
          <div key={item.key} className="op-scheduler-settings-panel__row">
            <label style={{ lineHeight: '34px', margin: '0' }}>{item.label}</label>
            {item.render ? (
              item.render()
            ) : (
              <DropDownListComponent
                id={item.key}
                dataSource={item.choices}
                fields={{ text: 'label', value: 'value' }}
                value={item.value}
                popupHeight={150}
                change={item.onChange}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default OpSchedulerSettingsPanel;
